export enum PersonalModuleRoutes {
    MY_ACCOUNT = 'my-account'
}
